module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [_c('div', {
    staticClass: "card card-box"
  }, [_c('a', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setItemSettings()
      }
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('h4', [_c('span', {
    staticStyle: {
      "float": "left",
      "font-size": "13px"
    }
  }, [_vm._v("Item Name ")]), _c('br'), _vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {}, [(_vm.product.product_images[0]) ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.product.product_images[0].product_image
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card card-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "p-row",
    attrs: {
      "id": "buyItem"
    }
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Buy Item ")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("Add to items you want to purchase ")]), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('AddToMarketList', 'buyItem')
      }
    }
  }, [_vm._v("\r\n                Add to Market List")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "AddToMarketList"
    }
  }, [_c('h5', [_vm._v("Buy Item")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "float": "right",
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('AddToMarketList', 'buyItem')
      }
    }
  }, [_vm._v("\r\n                x close")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('AddToMarketList', 'buyItem')
      }
    }
  }, [_vm._v("\r\n              Buy from Distributors")])])])]), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-row"
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Available ")]), _c('br'), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("0")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-row"
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Last Sold ")]), _c('br'), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("000-00-00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-row"
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Expiry Date ")]), _c('br'), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("000-00-00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_vm._v("Market Information\r\n            "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "13px"
    }
  }, [_c('i', {
    staticClass: "fas fa-shopping-bag"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-row"
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Last Purchase Amount ")]), _c('br'), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("0")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-row"
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Last Purchase Date ")]), _c('br'), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("000-00-00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-row"
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Purchased From ")]), _c('br'), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("000-00-00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "btn  btn-default",
    staticStyle: {
      "padding": "0.41em",
      "border-radius": "50%"
    }
  }), _vm._v(" Add to general market list")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "padding": "0.41em",
      "border-radius": "50%"
    }
  }), _vm._v(" Add to market list with "), _c('b')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-row"
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Direct Access ")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("Send your list to distributors tat sell these products")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4')]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-184be450"}!./src/pages/Manage/Item/template.html
// module id = 549
// module chunks = 0